module.exports = __webpack_public_path__ + "static/media/cloud-sync-outline.494930ce.svg";